import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface FinCstRommsProps {
  onBack: () => void;
}

export default function FinCstRomms({ onBack }: FinCstRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Finance Costs" />;
}



